// src/pages/Employee/CreateEmployee/steps/Step7EmergencyReference.tsx

import React from 'react';
import { Row, Col, FormGroup, Label, Input, FormFeedback } from 'reactstrap';
import { Phone, UserCheck } from 'react-feather';
import { EmergencyReferenceData, StepProps } from '../../types/employee.types';

const Step7EmergencyReference: React.FC<StepProps<EmergencyReferenceData>> = ({ data, onChange, errors }) => {
  const set = (field: keyof EmergencyReferenceData, value: string) => {
    onChange({ ...data, [field]: value });
  };

  return (
    <div>
      <h6 className="mb-3 d-flex align-items-center gap-2">
        <Phone size={16} />
        Emergency Contact
      </h6>
      <Row>
        <Col md={3}>
          <FormGroup>
            <Label className="fw-bold text-muted small text-uppercase">
              Name
            </Label>
            <Input
              value={data.emergency_name}
              invalid={!!errors.emergency_name}
              onChange={(e) => set('emergency_name', e.target.value)}
            />
            <FormFeedback>{errors.emergency_name}</FormFeedback>
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            <Label className="fw-bold text-muted small text-uppercase">
              Relationship
            </Label>
            <Input
              value={data.emergency_relationship}
              invalid={!!errors.emergency_relationship}
              onChange={(e) => set('emergency_relationship', e.target.value)}
            />
            <FormFeedback>{errors.emergency_relationship}</FormFeedback>
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            <Label className="fw-bold text-muted small text-uppercase">
              Mobile
            </Label>
            <Input
              value={data.emergency_mobile}
              invalid={!!errors.emergency_mobile}
              onChange={(e) => set('emergency_mobile', e.target.value.replace(/[^\d+]/g, ''))}
            />
            <FormFeedback>{errors.emergency_mobile}</FormFeedback>
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            <Label className="fw-bold text-muted small text-uppercase">Email</Label>
            <Input
              type="email"
              value={data.emergency_email}
              onChange={(e) => set('emergency_email', e.target.value)}
            />
          </FormGroup>
        </Col>
      </Row>

      <div className="border-top pt-3 mt-2">
        <h6 className="mb-3 d-flex align-items-center gap-2">
          <UserCheck size={16} />
          Reference
        </h6>
        <Row>
          <Col md={4}>
            <FormGroup>
              <Label className="fw-bold text-muted small text-uppercase">
                Name
              </Label>
              <Input
                value={data.reference_name}
                invalid={!!errors.reference_name}
                onChange={(e) => set('reference_name', e.target.value)}
              />
              <FormFeedback>{errors.reference_name}</FormFeedback>
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <Label className="fw-bold text-muted small text-uppercase">Designation</Label>
              <Input
                value={data.reference_designation}
                onChange={(e) => set('reference_designation', e.target.value)}
              />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <Label className="fw-bold text-muted small text-uppercase">
                Mobile
              </Label>
              <Input
                value={data.reference_mobile}
                invalid={!!errors.reference_mobile}
                onChange={(e) => set('reference_mobile', e.target.value.replace(/[^\d+]/g, ''))}
              />
              <FormFeedback>{errors.reference_mobile}</FormFeedback>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={8}>
            <FormGroup>
              <Label className="fw-bold text-muted small text-uppercase">Address</Label>
              <Input
                type="textarea"
                rows={2}
                value={data.reference_address}
                onChange={(e) => set('reference_address', e.target.value)}
              />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <Label className="fw-bold text-muted small text-uppercase">Email</Label>
              <Input
                type="email"
                value={data.reference_email}
                onChange={(e) => set('reference_email', e.target.value)}
              />
            </FormGroup>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Step7EmergencyReference;